import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { class: "new-table" }
const _hoisted_2 = ["colspan"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" No data available ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (head) => {
          return (_openBlock(), _createElementBlock("th", {
            key: head.text,
            class: _normalizeClass(head.class)
          }, _toDisplayString(head.text), 3))
        }), 128))
      ])
    ]),
    _createElementVNode("tbody", null, [
      _createElementVNode("tr", null, [
        (!_ctx.items.length)
          ? (_openBlock(), _createElementBlock("td", {
              key: 0,
              colspan: _ctx.headers.length,
              class: "text-center"
            }, [
              _renderSlot(_ctx.$slots, "empty-message", {}, () => [
                _hoisted_3
              ])
            ], 8, _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: item.id
        }, [
          (_ctx.items.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.headers, (column) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: column.value,
                  class: _normalizeClass(column.class)
                }, [
                  _renderSlot(_ctx.$slots, column.value, _normalizeProps(_guardReactiveProps({ item: item })), () => [
                    _createTextVNode(_toDisplayString(item[column.value]), 1)
                  ])
                ], 2))
              }), 128))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}